import React from 'react';
import { Link } from 'gatsby';

import UrlHelper from '../../lib/utils/url-helper';

// Gatsby-hosted file assets (e.g. Contentful downloads copied via `publicUrl`) aren't pages,
// so they must never be routed through Gatsby's <Link> and shouldn't pass link equity.
const isGatsbyFileAsset = (url = '') => url.includes('/_gatsby/file/');

export const isInternalLink = (url = '') =>
  !isGatsbyFileAsset(url) && /^\/(?!\/)/.test(UrlHelper.formatInternalUrl(url));

const SmartLink = ({
  to,
  href,
  children,
  activeClassName,
  partiallyActive,
  rel,
  ...other
}) => {
  const url = to || href || '';
  const formattedUrl = UrlHelper.formatInternalUrl(url);

  if (!formattedUrl) {
    return <a href="#" {...other}>{children}</a>;
  }

  if (
    formattedUrl.startsWith('mailto:') ||
    formattedUrl.startsWith('tel:') ||
    formattedUrl.startsWith('#') ||
    !isInternalLink(formattedUrl)
  ) {
    const linkRel = isGatsbyFileAsset(formattedUrl)
      ? [rel, 'nofollow'].filter(Boolean).join(' ')
      : rel;

    return <a href={formattedUrl} rel={linkRel} {...other}>{children}</a>;
  }

  return (
    <Link
      to={formattedUrl}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      {...other}
    >
      {children}
    </Link>
  );
};

export default SmartLink;
